/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import { service } from "@ember/service";
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import type SemeiaSessionService from "parog-web/services/session";

interface Signature {
  Args: {
    messageContent?: unknown;
    onMedicalEventClicked?: unknown;
    onSendMessage?: unknown;
    onFileUploadClicked?: unknown;
    messageIsBeingSent?: unknown;
    onSuggestionSelected: (suggestion: string) => void;
  };
}
export default class ChatSuggestionsComponent extends Component<Signature> {
  @service declare session: SemeiaSessionService;

  @tracked shouldShowSuggestions = false;

  buttonStyle =
    "flex justify-center items-baseline py-[1em] [&button]:mb-[0.5em]";

  @action
  showSuggestions(): void {
    this.shouldShowSuggestions = !this.shouldShowSuggestions;

    if (this.shouldShowSuggestions) {
      // If suggestions are shown, scroll to bottom to see them
      setTimeout(() => window.scrollTo(0, document.body.scrollHeight), 0);
    }
  }

  @action
  onSuggestionSelected(selectedSuggestion: string): void {
    this.args.onSuggestionSelected(selectedSuggestion);

    this.shouldShowSuggestions = false;
  }
}
